import { render, staticRenderFns } from "./OnboardingEmail.vue?vue&type=template&id=60572938&"
import script from "./OnboardingEmail.vue?vue&type=script&lang=js&"
export * from "./OnboardingEmail.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingEmail.vue?vue&type=style&index=0&id=60572938&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports